export const fetchFileName = (link) => {
  let url = link.split("/");
  let filename = url[url.length - 1];
  return filename.slice(filename.indexOf("_") + 1);
};

export const downloadFromLink = (link) => {
  fetch(link, { mode: "cors" })
    .then((response) => response.blob())
    .then((blob) => {
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "file.pdf";
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    })
    .catch(console.error);
};
